/**
 *  LightningBoost
 *
 *  Created by Legman on 07/06/2017.
 *
 */

import Boost from "./Boost";
import Common from "../Common";

/**
 * @class
 * @extends Boost
 */
export default class LightningBoost extends Boost  {
    /**
     * @param owner
     */
    constructor(owner) {
        super(owner);

        /**
         * @type {null}
         * @private
         */
        this._emitter = null;
    }

    init() {
        const assets = Common.assets;
        const config = assets.getJSON("particle_emitter_lightning_speed_00");

        const holder = new PIXI.Container();
        holder.y = 40;
        this.addChild(holder);

        this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particle_powerup_lightningspeed_01")], config);

        super.init();
    }

    destroy(options) {
        super.destroy(options);

        this._emitter.destroy();
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        super.update(dt);
        this._emitter.update(dt);
    }

    /**
     * @protected
     */
    _startBoost() {
        super._startBoost();

        this._emitter.emit = true;
    }

    /**
     * @protected
     */
    _stopBoost() {
        super._stopBoost();

        delay(function() {
            this._emitter.emit = false;
        }, 1, this);

        delay(function() {
            this.parent && this.parent.removeChild(this);
        }, 2, this);
    }
}